import { render, staticRenderFns } from "./ComplementaInformacion.vue?vue&type=template&id=54b2ffe2&scoped=true"
import script from "./ComplementaInformacion.vue?vue&type=script&lang=js"
export * from "./ComplementaInformacion.vue?vue&type=script&lang=js"
import style0 from "./ComplementaInformacion.vue?vue&type=style&index=0&id=54b2ffe2&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b2ffe2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54b2ffe2')) {
      api.createRecord('54b2ffe2', component.options)
    } else {
      api.reload('54b2ffe2', component.options)
    }
    module.hot.accept("./ComplementaInformacion.vue?vue&type=template&id=54b2ffe2&scoped=true", function () {
      api.rerender('54b2ffe2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/procesos/constitucion/complementainformacion/ComplementaInformacion.vue"
export default component.exports